import Link from "next/link";

export default function AnnouncementText() {
    return (
        <div className="flex w-max gap-8 px-6 whitespace-nowrap">
            {/* Desktop */}
            <div className="hidden md:flex">
                <Text />
            </div>

            {/* Mobile marquee */}
            <div className="flex md:hidden animate-marquee gap-8">
                <Text />
                <Text />
            </div>
        </div>
    );
}


function Text() {
    return (
        <div className="flex items-center gap-2">
            <strong className="hidden md:block">
                Lembaga Pelatihan Kerja Terakreditasi
            </strong>
            <strong className="md:hidden block">
                Lembaga Pelatihan Kerja Terakreditasi KMPI
            </strong>

            <span className="italic hidden sm:inline">
                sesuai Kerangka Mutu Pelatihan Indonesia
            </span>

            <Link
                href="https://wa.me/6281215636018"
                target="_blank"
                className="font-semibold text-blue-700 underline underline-offset-4"
            >
                Daftar sekarang
            </Link>
        </div>
    );
}
